import { render, staticRenderFns } from "./moveDetail.vue?vue&type=template&id=2933e890&scoped=true&"
import script from "./moveDetail.vue?vue&type=script&lang=js&"
export * from "./moveDetail.vue?vue&type=script&lang=js&"
import style0 from "./moveDetail.vue?vue&type=style&index=0&id=2933e890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2933e890",
  null
  
)

export default component.exports